export const spacing = {
    SMALL: 4,
    MEDIUM: 8,
    LARGE: 16,
};
